import { ChangeEvent, useRef } from 'react';
import { useAttachFileService } from '../../FileAttachment';
import { UseCreateFileArgs } from './useCreateFile';

export const useCreateFileV2 = ({
  itemID,
  tenantID,
  standalone,
  onFileCreation,
  onFileAttachmentCreation,
}: UseCreateFileArgs) => {
  const { attachFileService } = useAttachFileService();
  const fileSelectorRef = useRef<HTMLInputElement>(null);

  const onSelectFile = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    attachFileService.mutate({
      file,
      itemID,
      tenantID,
      standalone,
      createFileAttachmentMutationOptions: {
        onSuccess: ({ fileAttachment }) => {
          if (fileSelectorRef.current) fileSelectorRef.current.value = '';
          onFileAttachmentCreation?.(fileAttachment.file, fileAttachment.id);
        },
      },
      createFileServiceOptions: {
        onSuccess: (file) => {
          if (file) onFileCreation?.(file);
        },
      },
    });
  };

  return {
    onSelectFile,
    fileSelectorRef,
    loading: attachFileService.isLoading,
  };
};
